<template>
    <div class="text-center m-t-2 m-b-12">
        <router-link
            v-if="['register', 'passwordResetStepOne'].indexOf($route.name) !== -1"
            :to="{ name: 'login' }"
            class="text-black"
        >
            Logowanie

            <i class="m-l-1 f-3 fas fa-arrow-right"></i>
        </router-link>

        <router-link
            v-if="['login', 'activate'].indexOf($route.name) !== -1"
            :to="{ name: 'register' }"
            class="text-black"
        >
            Zarejestruj się

            <i class="m-l-1 f-3 fas fa-arrow-right"></i>
        </router-link>
    </div>
</template>
